import { pipe } from 'ramda';

import { buildCmsUrl, getResponseCMS } from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface CmsABTest {
  title: string;
  version?: string;
}

export const ABTestsCMSV3 = () =>
  request<CmsABTest[]>({ url: buildCmsUrl({ path: 'ab-tests' }) });

export const ABTestsCMSV4 = () =>
  request<CmsABTest[]>({
    url: buildCmsUrl({ path: 'ab-tests' }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<CmsABTest[]>
    ),
  });

export const ABTestsCMS = isCMSV3 ? ABTestsCMSV3 : ABTestsCMSV4;
